import axios from 'axios';

const { GET_PROFILE, PROFILE_ERROR, REMOVE_ONE_EXP, CHANGE_PROF_PIC,
CLEAR_PROFILE, MAKE_FOLLOWING, MAKE_UNFOLLOWING, OPEN_EDIT_DETAILS,
ADD_ONE_EXP, UPDATE_PROFILE_EXPS, GET_FOLLOWERS, GET_FOLLOWING,
SET_LOADING_TRUE, UPDATE_ONE_EXP, UPDATE_USER_INFO } = require("../types");
 

export const getCurrentProfile = (userIdParam, signedInId) => async dispatch => { 

  let responseData;  
  try {
    responseData =
    await axios.get(`${process.env.REACT_APP_BACKEND_URL}/${userIdParam}/${signedInId}`);
  }catch(err) {
    return dispatch({
      type: PROFILE_ERROR,
      payload: err
    })
  }
  dispatch({
    type: GET_PROFILE,  
    payload: {a: responseData.data, b: userIdParam} 
  }); 

};

export const updateUserInfo = (info) => dispatch => {
  dispatch({
    type: UPDATE_USER_INFO, 
    payload: info
  })
}

export const updateProfileExps = (userId, page) => async dispatch => { 

  let responseData;
  try {
    responseData = 
    await axios.get(`${process.env.REACT_APP_BACKEND_URL}/upExps/${userId}/${page}`);
    
  }catch(err) { 
    
  }

  dispatch({
    type: UPDATE_PROFILE_EXPS,
    payload: responseData.data.userExperiences
  })

}


export const getFollowers = (userId) => async dispatch => {

  let responseData; 
  try {
    responseData = 
    await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get/followers/${userId}`);
    
  }catch (err) { 
    dispatch({
      type: GET_FOLLOWERS,
      payload: [] 
    })
  }

  dispatch({
    type: GET_FOLLOWERS,
    payload: responseData.data.followersList
  })

}


export const getFollowing = (userId) => async dispatch => {

  let responseData; 
  try {
    responseData = 
    await axios.get(`${process.env.REACT_APP_BACKEND_URL}/get/following/${userId}`);
    
  }catch (err) { 
    dispatch({
      type: GET_FOLLOWING,
      payload: [] 
    })
  }

  dispatch({
    type: GET_FOLLOWING,
    payload: responseData.data.followingList
  })

}


export const makeFollowing = () => dispatch => {
  dispatch({
    type: MAKE_FOLLOWING  
  })
}

export const makeUnfollowing = () => dispatch => {
  dispatch({
    type: MAKE_UNFOLLOWING
  })
}



export const addOneExp = (exp) => dispatch => {
  dispatch({
    type: ADD_ONE_EXP, 
    payload: exp 
  })
}


export const removeOneExp = (expId) => dispatch => {
  dispatch({
    type: REMOVE_ONE_EXP,
    payload: expId 
  })
}


export const clearProfile = () => dispatch => {
  dispatch({
    type: CLEAR_PROFILE 
  })
}


export const setChangeProfPic = (a) => dispatch => {
  dispatch({
    type: CHANGE_PROF_PIC,
    payload: a
  })
}

export const updateOneExp = (exp) => dispatch => {
  dispatch({
    type: UPDATE_ONE_EXP,
    payload: exp
  })
}

export const openEditDetails = (a) => dispatch => {
  dispatch({
    type: OPEN_EDIT_DETAILS,
    payload: a
  })
};


